module.exports = __webpack_public_path__ + "fonts/Montserrat-MediumItalic.add94c6.eot";